import HeaderDesktop from "components/headers/HeaderDesktop";
import HeaderMobile from "components/headers/HeaderMobile";
import useBreakpoints from "hooks/dimensions/useBreakpoints";

export default function Header() {
  const { isWidth1024Breakpoint } = useBreakpoints();

  return isWidth1024Breakpoint ? <HeaderMobile /> : <HeaderDesktop />;
}
